// extracted by mini-css-extract-plugin
export var tasks__item = "tasks-module--tasks__item--5ddae";
export var tasks__number = "tasks-module--tasks__number--2350a";
export var tasks__number_1 = "tasks-module--tasks__number_1--08886";
export var tasks__number_2 = "tasks-module--tasks__number_2--01436";
export var tasks__number_3 = "tasks-module--tasks__number_3--10c18";
export var tasks__text = "tasks-module--tasks__text--28d93";
export var tasks__text_reverse = "tasks-module--tasks__text_reverse--5c9d5";
export var tasks__title = "tasks-module--tasks__title--b10bf";
export var tasks__vid = "tasks-module--tasks__vid--e274e";
export var tasks__vid_bg = "tasks-module--tasks__vid_bg--d68db";
export var tasks__vid_title = "tasks-module--tasks__vid_title--4befe";
export var tasks__vid_wrapper = "tasks-module--tasks__vid_wrapper--73edb";
export var tasks__vid_wrapper_iframe = "tasks-module--tasks__vid_wrapper_iframe--7a2f7";
export var tasks__wrapper = "tasks-module--tasks__wrapper--9df21";